module.exports = __webpack_public_path__ + "bcbbe5786be093919bea4ae986379d1a.png";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/logos/logo-invoice.png
 ** module id = 1551
 ** module chunks = 1
 **/